'use client';
import CategoryGrid, { GridType } from '@components/shared/CategoryGrid';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { useState, memo } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import GridItem from '../shared/StoriesGridItem';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import axios from 'axios';
import useUpdateEffect from '@hooks/useUpdateEffectt';
import Section from '@repo/ui/src/components/Section';
import CircularProgress from '@mui/material/CircularProgress';

const StoriesGrid = ({ title, filters, sortOptions, _data }) => {
  const { locale } = useCurrentUrl();
  const [data, setData] = useState(_data);
  const [currentTab, setCurrentTab] = useState(0);
  const [currentCategory, setCurrentCategory] = useState(
    filters?.categories?.length ? filters?.categories[0].value : null,
  );
  const [loading, setLoading] = useState(false);

  const getSortParam = (sort) => {
    if (!sort?.value) return null;
    const [field, direction] = sort.value.split(',');
    return { field, direction };
  };

  const loadData = async ({ page }, controller) => {
    return await axios.get('/api/stories/searchStories', {
      params: {
        page,
        filters: currentCategory ? { categories: currentCategory } : null,
        sort: getSortParam(sortOptions?.length ? sortOptions[0] : null),
        lang: locale,
      },
      signal: controller.signal,
    });
  };

  const selectTab = (categoryValue, index) => {
    setCurrentTab(index);
    setCurrentCategory(categoryValue);
  };

  useUpdateEffect(async () => {
    setLoading(true);
    const res = await loadData({ page: 0 });
    setData(res.data);
    setLoading(false);
  }, [currentCategory]);

  return (
    <Section gutterX basePadding white>
      {title && (
        <Typography variant="h2" align="center">
          {title}
        </Typography>
      )}
      {filters?.categories && (
        <Box display="flex" justifyContent="center" py={{ xs: 2, md: 4 }}>
          <Tabs
            value={currentTab}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            sx={{ mx: -3 }}
          >
            {filters?.categories.map((category, i) => (
              <Tab
                key={`${category.value}_{i}`}
                label={category.name}
                onClick={() => selectTab(category.value, i)}
              />
            ))}
          </Tabs>
        </Box>
      )}
      {loading && (
        <Box display="flex" justifyContent="center" sx={{ position: 'relative' }}>
          <CircularProgress
            size={100}
            thickness={4}
            color="primary"
            sx={{ position: 'absolute', top: 50, zIndex: 1 }}
          />
        </Box>
      )}
      <CategoryGrid
        _data={data}
        loadData={loadData}
        GridItemComponent={GridItem}
        type={GridType.Story}
        gridCardOverrides={{ xs: 12 }}
        darkBackground
        disableBorder
      />
    </Section>
  );
};

export default memo(StoriesGrid);
